'use client';

import { useEffect, useState } from 'react';

import { detectIncognito } from 'detectincognitojs';

let incognitoDetection: Promise<boolean> | null = null;

const useIsIncognito = () => {
    const [incognito, setIncognito] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        let isMounted = true;

        detectIncognitoOnce().then((result) => {
            if (isMounted) {
                setIncognito(result);
            }
        });

        return () => {
            isMounted = false;
        };
    }, []);

    return incognito;
};

const detectIncognitoOnce = () => {
    incognitoDetection ??= detectIncognito()
        .then(({ isPrivate }) => isPrivate)
        .catch(() => false);

    return incognitoDetection;
};

export { useIsIncognito };
